module.exports = __webpack_public_path__ + "img/bcc018.e6746439.jpeg";